import React from "react";
import { Chip, styled } from "@mui/material";

const StyledChip = styled(Chip)((props) => ({
  backgroundColor: props.backgroundcolor
}));

const StatusChip = ({ value, colorMap }) => {
  const colorKey = colorMap[value];

  return <StyledChip label={value} backgroundcolor={colorKey} size="small" />;
};

export default StatusChip;
